<template>
  <div class="jianli">
    <c-table
      ref="table"
      :fields="fields"
      :columns="columns"
      :url="`${$route.query.active === '7' ? '/zhaopin/jianli3' : '/zhaopin/jianli2'}`"
      @before-fetch="beforeFetch"
    >
      <email-table-column slot="email" field="jianli_email"></email-table-column>
      <el-table-column slot="jianli_name" label="姓名" class-name="pointer" width="100">
        <template v-slot="{row}">
          <div @click="view(row)">
            <span>{{row.jianli_name}}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column slot="zhiwei" label="应聘岗位" width="110">
        <template v-slot="{row}">
          <el-tooltip placement="top">
            <div slot="content">{{row | bumen}}</div>
            <span>{{row.zhiwei}}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column slot="status" label="状态" width="120">
        <template v-slot="{row}">
          <span v-html="covertResumeStatus(row)"></span>
        </template>
      </el-table-column>
      <el-table-column slot="caozuo" label="操作" width="180" fixed="right">
        <template v-slot="{row}">
          <el-button type="text" @click="detail(row.jianli_id)">详情</el-button>
          <el-button type="text" @click="download(row)">下载</el-button>
          <el-button type="text" @click="history = row.jianli_id">历史操作</el-button>
        </template>
      </el-table-column>
    </c-table>
    <history-modal v-model="history"></history-modal>
  </div>
</template>

<script>
import CTable from '@/components/common/table'
import DepartmentCascade from '@/components/service/department-cascade'
import HistoryModal from '@/components/service/history-modal'
import mixin from '@/mixins'

export default {
  name: 'jianli',
  mixins: [ mixin ],
  components: { CTable, HistoryModal },
  data () {
    const { active } = this.$route.query
    const paramEnum = {
      2: '3',
      3: '4',
      4: '5',
      5: '9',
      6: '-3'
    }
    return {
      loading: false,
      history: '',
      fields: [
        {
          prop: 'name',
          placeholder: '姓名',
          clearable: true
        },
        {
          prop: 'jianli_status_id',
          placeholder: '状态',
          clearable: true,
          component: 'select',
          visible: +active < 2 || this.$route.path.includes('resume'),
          value: +active > 1 ? paramEnum[ +active ] : '',
          options: this.$store.state.global.resume_status_enum
        },
        {
          prop: 'department',
          placeholder: '部门',
          component: DepartmentCascade,
          value: []
        },
        {
          prop: 'action',
          placeholder: '操作人',
          clearable: true,
          component: 'select',
          options: [
            {
              value: '1',
              label: '全部'
            },
            {
              value: '2',
              label: '不是我操作的'
            },
            {
              value: '3',
              label: '是我操作的'
            }
          ]
        }
      ],
      columns: [
        { slot: 'jianli_name' },
        { prop: 'jianli_mobile', label: '手机', width: 130 },
        { slot: 'email' },
        { prop: 'jianli_xuexiao', label: '学校', 'show-overflow-tooltip': true, width: 240 },
        { prop: 'jianli_xueli', label: '学历' },
        { prop: 'jianli_gender', label: '性别' },
        { prop: 'jianli_age', label: '年龄' },
        { slot: 'zhiwei' },
        { prop: 'jianli_laizi', label: '来源' },
        { slot: 'status' },
        { prop: 'action_name', label: '操作者', width: 100 },
        { slot: 'caozuo' }
      ],
      model: null
    }
  },
  methods: {
    beforeFetch (params) {
      [ (params.jiagou_first), (params.jiagou_second), (params.jiagou_third), (params.jiagou_forth) ] = params.department
      params.zhiwei_id = +this.$route.query.id
      delete params.department
    },
    detail (id) {
      // 看是否有active参数，有则拼接
      this.$route.query.active ? window.open(`/review/operable/${id}?active=${this.$route.query.active}`) : window.open(`/review/operable/${id}`)
    },
    showHistory (id) {
      this.history.loading = this.history.visible = true
      this.$http.post('zhaopin/zhiwei/detail2', {
        jianli_id: id
      }).then(res => {
        this.history.data = res.data.data
        this.history.data.forEach(item => {
          item = `${item.history_action}(${item.history_time})`
        })
        this.history.loading = false
      })
    },
    download (row) {
      const jianliId = row.jianli_id
      this.$http.get(`/zhaopin/jianli/download?i=${jianliId}`, {
        responseType: 'blob' // 指定返回数据的格式为blob
      }).then(res => {
        let link = document.createElement('a')
        let evt = document.createEvent('HTMLEvents')
        evt.initEvent('click', false, false)
        link.href = URL.createObjectURL(res.data)
        link.download = `${row.jianli_name}-${row.jianli_mobile}-${row.zhiwei}`
        link.style.display = 'none'
        document.body.appendChild(link)
        link.click()
        window.URL.revokeObjectURL(link.href)
      })
    }
  }
}
</script>

<style lang="scss">
</style>
